let windowURL;
let aElement = document.createElement('a');

export const downloadFile = (url, filename) => {
  fetch(url)
    .then(response => {
      if (response.status===200) {
       response.blob().then(blob => {
         windowURL = window.URL.createObjectURL(blob);
         const urlSplit = windowURL.split("/")
         aElement.href = windowURL;
         aElement.download = filename.includes("undefined") 
         ? urlSplit[urlSplit.length -1].concat(".", filename.split(".")[1])
         : filename;
         aElement.click();
       });
      } else {
     //alert("no se pudo descargar ");
      }
    }).catch(err =>{
     return err
    });
 }